/**
 * @generated SignedSource<<07ce494cd5e23a82ca54f8b4f98b1418>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraHorizontalNavigationContent$data = {
  readonly jira: {
    readonly containerNavigation: {
      readonly scopeId?: string | null | undefined;
    };
  } | null | undefined;
  readonly jira_projectByIdOrKey?: {
    readonly __id: string;
    readonly softwareBoardCount: AGG$Long | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"CustomTemplateProjectBanner" | "NavHeader_project" | "TabsContent_project" | "ThemeEvaluated">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"NavHeader_query" | "TabsContent_query">;
  readonly " $fragmentType": "JiraHorizontalNavigationContent";
};
export type JiraHorizontalNavigationContent$key = {
  readonly " $data"?: JiraHorizontalNavigationContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraHorizontalNavigationContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "containerNavigationInput"
    },
    {
      "kind": "RootArgument",
      "name": "projectIdOrKey"
    },
    {
      "kind": "RootArgument",
      "name": "withProject"
    }
  ],
  "kind": "Fragment",
  "name": "JiraHorizontalNavigationContent",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TabsContent_query"
    },
    {
      "kind": "FragmentSpread",
      "name": "NavHeader_query"
    },
    {
      "condition": "withProject",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            },
            {
              "kind": "Variable",
              "name": "idOrKey",
              "variableName": "projectIdOrKey"
            }
          ],
          "concreteType": "JiraProject",
          "kind": "LinkedField",
          "name": "jira_projectByIdOrKey",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "ThemeEvaluated"
            },
            {
              "kind": "FragmentSpread",
              "name": "TabsContent_project"
            },
            {
              "kind": "FragmentSpread",
              "name": "NavHeader_project"
            },
            {
              "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "CustomTemplateProjectBanner"
                }
              ]
            },
            {
              "kind": "ScalarField",
              "name": "softwareBoardCount"
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "__id"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "containerNavigationInput"
              }
            ],
            "kind": "LinkedField",
            "name": "containerNavigation",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "scopeId"
                  }
                ],
                "type": "JiraContainerNavigation"
              }
            ]
          },
          "action": "THROW",
          "path": "jira.containerNavigation"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "7653bac1b59edb8c24c1e8829b0acf5f";

export default node;
